import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActionResult, RaceRoute } from "@model";
import { Observable, map } from "rxjs";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class RaceRouteService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  fetchRaceRoute(raceId: number): Observable<RaceRoute | undefined> {
    return this.http.post<ActionResult<RaceRoute>>(this.environmentService.getApiUrl() + "/api/public/race/route/fetch", raceId).pipe(
      map(actionResult => actionResult.resultCode !== -1 ? actionResult.result : undefined)
    );
  }

  downloadGpx(path: string, onLoadend: (base64data: string) => void): void {
    this.http.get(path, { responseType: 'blob' }).subscribe((res: Blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result;
        if (typeof base64data === 'string') onLoadend(base64data);
      };
      reader.readAsDataURL(res);
    });
  }

  updateRaceRoute(raceRoute: RaceRoute, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/race/route/add", raceRoute).subscribe(
      actionResult => actionResult.resultCode !== -1 ? onSuccess() : onError()
    );
  }

  deleteRaceRoute(raceId: number, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/race/route/delete", raceId).subscribe(
      actionResult => actionResult.resultCode !== -1 ? onSuccess() : onError()
    );
  }
}
